import { observer } from "mobx-react";
import React from "react";
import { EmailCycleDetailsTab } from "./tabs/EmailCycleDetailsTab";
import { EmailCycleRecipientsTab } from "./tabs/EmailCycleRecipientsTab";

export enum EmailCycleDetailsTabs {
  CycleDetails = "cycleDetails",
  Respondents = "respondents",
}

interface EmailCycleDetailsTabContentProps {
  selectedTab: EmailCycleDetailsTabs;
}

export const EmailCycleDetailsPageContent: React.FC<EmailCycleDetailsTabContentProps> =
  observer(({ selectedTab }) => {
    switch (selectedTab) {
      case EmailCycleDetailsTabs.CycleDetails:
        return <EmailCycleDetailsTab />;
      case EmailCycleDetailsTabs.Respondents:
        return <EmailCycleRecipientsTab />;
      default:
        return selectedTab satisfies never;
    }
  });
